<template>
    <div class="flex flex-col justify-between h-44 p-4" :class="coloreAttivo">
        <p class="">
        {{ testoNotifica }}
        </p>
        <div class="flex justify-between items-baseline">
            <div class="text-xs">{{ date }}</div>
            <a v-show="mark_as_read" @click="markAsRead" class="text-xs hover:underline" href="javascript:void(0)">marca come letta</a>
            <router-link :to="to" class="underline flex justify-self-end text-sm">Vedi</router-link>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import notificheManager from "../api/Notifiche";

@Options({
    name:'Notifica',
    props: {
        testoNotifica: String,
        date: String,
        coloreAttivo: String,
        to: Object,
        id: String,
        mark_as_read: Boolean,
    }
})
export default class Notifica extends Vue {
    coloreAttivo!: string
    testoNotifica!: string
    date!: string
    id!: string

    markAsRead(){
        notificheManager.marcaComeLetta(this.id).then(()=>{
            this.$emit('read')
        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
